export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        webinars: action.webinars,
      };

    case 'CREATE':
      return {
        ...state,
        webinars: [action.webinar, ...state.webinars],
      };

    case 'UPDATE':
      return {
        ...state,
        webinars: state.webinars.map(
          (item) => (item.id === action.webinar.id ? action.webinar : item),
        ),
      };

    case 'DELETE':
      return {
        ...state,
        webinars: state.webinars.filter(
          (item) => parseInt(item.id, 10) !== parseInt(action.webinarId, 10),
        ),
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
